export default "__VITE_ASSET__CzqRoClw__"